<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-parking`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 24c0-11.046-8.954-20-20-20S4 12.954 4 24s8.954 20 20 20 20-8.954 20-20zM8 24c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16S8 32.837 8 24zm17-9c1.43 0 2.181.078 3.005.232.823.155 1.489.403 1.996.744A6.624 6.624 0 0132.2 18.47c.533 1.033.8 2.353.8 3.53 0 2.159-.715 3.669-2.144 4.96C29.426 28.25 27.424 29 25 29h-4v5a1 1 0 01-1 1h-2a1 1 0 01-1-1V16a1 1 0 011-1h7zm-4 4h4.137c1.298 0 2.219.217 2.857.79.64.573 1.006 1.128 1.006 2.21s-.367 1.617-.958 2.172c-.591.555-1.638.828-2.874.828H21v-6z"/></svg>
</template>
<script>

export default {
  name: 'IconParking',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
